import { render } from "./detail.vue?vue&type=template&id=12681f1b&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=12681f1b&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12681f1b"],['__file',"src/views/alfmeier/advertise/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12681f1b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12681f1b', __exports__)) {
    console.log('reload')
    api.reload('12681f1b', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=12681f1b&scoped=true", () => {
    console.log('re-render')
    api.rerender('12681f1b', render)
  })

}


export default __exports__